import React from "react";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div id="body">
      <section>
        <h1>{t("terms.title")}</h1>
        <p>{t("terms.intro")}</p>

        {Object.values(t("terms.sections", { returnObjects: true })).map(
          (section, index) => (
            <div key={index}>
              <h2>{section.title}</h2>
              {Object.values(section).map(
                (content, idx) => idx !== 0 && <p key={idx}>{content}</p>
              )}
            </div>
          )
        )}

        <p>
          {t("terms.sections.contact.info", { email: "linorajsc@gmail.com" })}
        </p>
      </section>
    </div>
  );
};

export default Terms;
